<template>
  <el-table-column
    prop="prefix"
    sortable="custom"
    label="Előtag"
    show-overflow-tooltip
    min-width="160"
    fixed
  >
    <template slot-scope="scope">
      {{ scope.row.prefix }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'prefix',
  };
</script>
